/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IEmployerState } from '../types';
import { Employers } from './types';

const initialState: Record<string, IEmployerState> = null;

export const employersReducer: Reducer<Record<string, IEmployerState>> = (state = initialState, action) => {
  switch (action.type) {
    case Employers.GET_EMPLOYERS_SUCCESS: {
      return action.payload as Record<string, IEmployerState>;
    }
    default: {
      return state;
    }
  }
};
